import React, { useLayoutEffect, useState } from "react";
import "./Choosegarment";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import { useTranslation } from "react-i18next";

const Garment = ({ onClick, data, editClick, deleteClick, admin }) => {
	const { t } = useTranslation();
	const [clrs, setClrs] = useState(0);
	useLayoutEffect(() => {
		setClrs(data.color.length > 4 && data.color.length - 4);
	}, []);
	return (
		<>
			<div className="shirt-img" onClick={onClick}>
				<img
					src={data.frontImg}
					alt="t-shirts"
					className="shirt"
					width={300}
					height={300}
				/>
			</div>
			<div className="shirt-details">
				<p className="clr_black">{data.garmentName.name}</p>
				<p>{`${t("from")} ${data.cost}`}€</p>
				<p>{data.garmentDescription}</p>
				<div className="clr-plate">
					{data.color.slice(0, 4).map((data, ind) => {
						return (
							<>
								<span style={{ background: data }}></span>
							</>
						);
					})}
					{clrs > 0 && <span className="clr_no">+{clrs}</span>}
				</div>
				{admin && (
					<div>
						<IconButton onClick={editClick}>
							<EditIcon />
						</IconButton>
						<IconButton onClick={deleteClick}>
							<DeleteIcon />
						</IconButton>
					</div>
				)}
			</div>
		</>
	);
};
export default Garment;
